import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../../../../../theme';
import { isExistI18nTranslate } from '../../../../../../utils';
import { CdnIcon, SafeHtml } from '@shared/ui';

interface Props {
	className?: string;
}

const Conditions: React.FC<Props> = ({ className }) => {
	const { Conditions: css } = useTheme('Checkin');
	const { t } = useTranslation('CheckinConditions');

	return (
		<div className={cn(css.container, className)}>
			<div className={css.title}>{t('Check-in conditions')}</div>
			<div className={css.icon}>
				<CdnIcon icon="Document/Boarding pass" />
			</div>
			<ul className={css.conditions}>
				{[...Array(10)].map((_, index) => {
					const key = `Rules_${index}`;
					const isExistTranslate = isExistI18nTranslate(key, { ns: 'CheckinConditions' });

					if (!isExistTranslate) {
						return null;
					}

					return <SafeHtml key={index} tag="li" html={t(key)} />;
				})}
			</ul>
		</div>
	);
};

export default Conditions;
